import React from "react";
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { ErrorBoundary } from "@/lib/errorBoundary";
import { FacebookPixelProvider } from "@/components/FacebookPixelProvider";
import { resetReloadGuard } from "@/lib/pwa/updateLifecycle";

// Tras cualquier arranque normal, liberar la guardia anti-bucle de recarga.
resetReloadGuard();

// Registrar Service Worker para funcionalidad PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' })
      .then((registration) => {
        console.log('✅ Plaxter SW registrado:', registration.scope);
        
        // Verificar actualizaciones periódicamente sin competir con la navegación.
        setInterval(() => {
          registration.update().catch(() => undefined);
        }, 60 * 60 * 1000);
      })
      .catch((error) => {
        console.log('❌ Plaxter SW falló:', error);
      });
  });
}

window.addEventListener('unhandledrejection', (event) => {
  console.error('Promesa no controlada:', event.reason);
});

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <FacebookPixelProvider>
        <App />
      </FacebookPixelProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
